import { gql } from '@apollo/client';
import TENANT_ELEMENT from 'api/fragments/TENANT_ELEMENT';
const GET_CURRENT_TENANT_ELEMENTS = gql `
  ${TENANT_ELEMENT}
  query GetCurrentTenantElements($first: Int, $after: String, $name: String) {
    me {
      id
      currentTenant {
        id
        elements(first: $first, after: $after, name: $name) {
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              ...TenantElementFragment
            }
          }
        }
      }
    }
  }
`;
export default GET_CURRENT_TENANT_ELEMENTS;
